import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/internal/operators/map';
import { ProfileAPI } from '../profile_api/constants/profile.constant';
import { HttpMethodsService } from '../_helpers/http-methods.service';

@Injectable({
  providedIn: 'root'
})
export class InstallationPackageService {
  userId = sessionStorage.getItem(ProfileAPI.USER_ID);
  COMMON_URL = `${ProfileAPI.SLASH_PROFILE}${ProfileAPI.SLASH_USER_ID}${ProfileAPI.SLASH}${this.userId}`;

  constructor(private httpMethod: HttpMethodsService) { }

  generateInstalltionPackage(profileId: string, queryParam: any) {
    const url = `${this.COMMON_URL}${ProfileAPI.PROFILES_URL}${ProfileAPI.SLASH}${profileId}`;

    let params = new HttpParams();
    params = params.append(ProfileAPI.ACTION, queryParam[0])
        .append(ProfileAPI.OPERATING_SYSTEM, queryParam[1])
        .append(ProfileAPI.PACKAGE_TYPE, queryParam[2]);
    // if(queryParam?.length>3){
    //   params = params.append(ProfileAPI.RETAILER_ID_ATTR_NAME,queryParam[3]);
    // } *** Commented code for later release IIT2-14840
    return this.httpMethod.patch(url, null, false, params)
    .pipe(map((res: any) =>
      res));
  }
}
